import React, { useState } from "react";
import { AgeRange, useAgeRanges } from "./useAgeRanges";

interface AgeFilterSectionProps {
  isSelected: boolean;
  onToggleSelect: () => void;
  onRangesChange: (ranges: AgeRange[]) => void;
}

export const AgeFilterSection: React.FC<AgeFilterSectionProps> = ({
  isSelected,
  onToggleSelect,
  onRangesChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { ranges, addRange, removeRange, updateRange, resetRanges } = useAgeRanges();

  const handleRangeUpdate = (id: string, field: "from" | "to", val: number) => {
    updateRange(id, field, val);
    // Περνάμε τα updated ranges πίσω στο Sidebar
    const updated = ranges.map((r) => (r.id === id ? { ...r, [field]: val } : r));
    onRangesChange(updated);
  };

  const handleAddRange = () => {
    addRange();
    onRangesChange(ranges);
  };

  const handleRemoveRange = (id: string) => {
    removeRange(id);
    onRangesChange(ranges);
  };

  return (
    <div className="flex flex-col gap-1">
      {/* Κύριο Κουμπί Επιλογής Ηλικίας */}
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={onToggleSelect}
          className={`flex-1 text-left px-3 py-2 text-sm font-medium rounded border transition-colors ${
            isSelected
              ? "bg-primary text-white border-primary shadow-sm"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
          }`}
        >
          Ηλικία
        </button>

        {/* Μικρό κουμπί για να ανοιγοκλείνει το Panel των Διαστημάτων */}
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className="px-2 py-2 text-xs font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded transition-colors"
          title="Ρύθμιση διαστημάτων"
        >
          {isOpen ? "▲" : "⚙"}
        </button>
      </div>

      {/* Πτυσσόμενο Panel Διαστημάτων */}
      {isOpen && (
        <div className="p-3 bg-white rounded-md border border-gray-200 text-xs flex flex-col gap-2 shadow-inner">
          <div className="flex justify-between items-center text-gray-500 font-semibold px-1">
            <span>Από</span>
            <span>Έως</span>
            <span className="w-4"></span>
          </div>

          {ranges.map((range) => (
            <div key={range.id} className="flex items-center justify-between gap-1">
              <input
                type="number"
                value={range.from}
                onChange={(e) =>
                  handleRangeUpdate(range.id, "from", parseInt(e.target.value) || 0)
                }
                className="w-14 p-1 border border-gray-300 rounded text-center bg-gray-50 focus:bg-white focus:ring-1 focus:ring-primary outline-none"
              />
              <span className="text-gray-400">-</span>
              <input
                type="number"
                value={range.to}
                onChange={(e) =>
                  handleRangeUpdate(range.id, "to", parseInt(e.target.value) || 0)
                }
                className="w-14 p-1 border border-gray-300 rounded text-center bg-gray-50 focus:bg-white focus:ring-1 focus:ring-primary outline-none"
              />

              {ranges.length > 1 ? (
                <button
                  type="button"
                  onClick={() => handleRemoveRange(range.id)}
                  className="text-red-500 hover:text-red-700 font-bold px-1 text-sm"
                  title="Αφαίρεση"
                >
                  ✕
                </button>
              ) : (
                <span className="w-4"></span>
              )}
            </div>
          ))}

          <div className="flex justify-between items-center mt-1 pt-2 border-t border-gray-100">
            <button
              type="button"
              onClick={resetRanges}
              className="text-[10px] text-gray-400 hover:text-gray-600 underline"
            >
              Reset
            </button>

            <button
              type="button"
              onClick={handleAddRange}
              className="flex items-center justify-center w-5 h-5 bg-primary text-white rounded-full text-xs font-bold hover:opacity-90 shadow-sm"
              title="Προσθήκη νέου διαστήματος"
            >
              +
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgeFilterSection;